import { useState, useEffect } from "react";
import { getCountry, type CountryItem } from "@/apis/addressApi";

// ==================== 全局缓存 ====================
let countryCache: CountryItem[] | null = null;
let countryPromise: Promise<CountryItem[]> | null = null;

// ==================== 自定义 Hook ====================
/**
 * 获取国家列表，使用全局缓存避免重复请求
 * @returns { countryList, loading }
 */
export const useCountryList = () => {
  const [countryList, setCountryList] = useState<CountryItem[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // 如果已有缓存，直接使用
    if (countryCache !== null) {
      setCountryList(countryCache);
      return;
    }

    // 如果正在请求中，等待同一个 Promise
    if (countryPromise) {
      setLoading(true);
      countryPromise
        .then((data) => {
          setCountryList(data);
          setLoading(false);
        })
        .catch(() => {
          setCountryList([]);
          setLoading(false);
        });
      return;
    }

    // 发起新请求
    setLoading(true);
    countryPromise = (async () => {
      try {
        const response = await getCountry();
        const data = Array.isArray(response?.data?.data)
          ? response.data.data
          : Array.isArray(response?.data)
            ? response.data
            : [];
        countryCache = data;
        setCountryList(data);
        return data;
      } catch (error) {
        console.error("Failed to fetch countries:", error);
        countryCache = [];
        setCountryList([]);
        return [];
      } finally {
        setLoading(false);
        countryPromise = null;
      }
    })();
  }, []);

  return { countryList, loading };
};
